const SubmittedProposalsReportTypes = {
  SUBMITTED_PROPOSALS_REPORT_FETCH_START:
    "submitted_proposals_report_fetch_start",
  SUBMITTED_PROPOSALS_REPORT_FETCH_SUCCESS:
    "submitted_proposals_report_fetch_success",
  SUBMITTED_PROPOSALS_REPORT_FETCH_FAILURE:
    "submitted_proposals_report_fetch_failure",
  SUBMITTED_PROPOSALS_REPORT_FETCH_RESET_START:
    "submitted_proposals_report_fetch_reset_start",
  SUBMITTED_PROPOSALS_REPORT_FETCH_RESPONSE_CHANGED:
    "submitted_proposals_report_fetch_changed",

  //*************************SUBMITTED PROPOSALS REPORT EXPORT START *********************//
  SUBMITTED_PROPOSALS_REPORT_EXPORT_START:
    "submitted_proposals_report_export_start",
  SUBMITTED_PROPOSALS_REPORT_EXPORT_SUCCESS:
    "submitted_proposals_report_export_success",
  SUBMITTED_PROPOSALS_REPORT_EXPORT_FAILURE:
    "submitted_proposals_report_export_failure",
  SUBMITTED_PROPOSALS_REPORT_EXPORT_RESET_START:
    "submitted_proposals_report_export_reset_start",
  SUBMITTED_PROPOSALS_REPORT_EXPORT_CHANGED:
    "submitted_proposals_report_export_changed",
};
export default SubmittedProposalsReportTypes;
